import Vue from "vue";
import VueRouter, { RouterOptions } from "vue-router";
import posthog from 'posthog-js';
import store, { storeModules } from "../store";

import EtcRoutes from "./etc-routes";
import AppRoutes from './app-routes';
import EventBus from "../utils/event-bus";
import { EVENT_BUS, ROUTER } from "../common/constants";
import ModuleType from "../common/module-constant";
import KanbanWebsite from "../containers/kanban-website/KanbanWebsiteComponent.vue";

Vue.use(VueRouter);

// Define kanban routes
const kanbanWebsiteRoutes = [
    {
        path: "/kanban-website",
        name: ROUTER.KANBAN,
        component: KanbanWebsite,
        meta: {
            title_key: "KANBAN_BETA",
            icon_name: "el-icon-s-grid",
            standalone: true,
            moduleType: ModuleType.Kanban
        },
        props: {}
    }
];

// Build base routes (without kanban initially)
let routes = [
    ...AppRoutes,
    ...EtcRoutes
];

let config: RouterOptions = {
    routes: routes,
    linkActiveClass: "active"
};

const historyModeEl = document.querySelector("meta[name='History-Mode']");

if (historyModeEl || location.port == '82') {
    config.mode = "history";
    config.base = "/";
}

const router: VueRouter = new VueRouter(config);
const commonModule = `${storeModules.Common}`;

// Flag to track if kanban routes have been added
let kanbanRoutesAdded = false;

// Function to add kanban routes dynamically
function addKanbanRoutes() {
    if (!kanbanRoutesAdded && posthog.isFeatureEnabled('kanban-board')) {
        console.log('Adding kanban routes dynamically');
        kanbanWebsiteRoutes.forEach(route => {
            router.addRoute(route as any);
        });
        kanbanRoutesAdded = true;
        return true;
    }
    return false;
}

// Check for PostHog readiness and add routes
function waitForPostHogAndAddRoutes() {
    // Try immediately first
    if (addKanbanRoutes()) {
        return;
    }

    // If PostHog has onFeatureFlags method, use it
    if (typeof posthog.onFeatureFlags === 'function') {
        posthog.onFeatureFlags(() => {
            addKanbanRoutes();
        });
    } else {
        // Fallback: poll for feature flag availability
        let retryCount = 0;
        const maxRetries = 10;
        const retryInterval = 1000;

        const checkInterval = setInterval(() => {
            retryCount++;
            console.log(`Checking PostHog readiness - Attempt ${retryCount}`);
            
            if (addKanbanRoutes()) {
                clearInterval(checkInterval);
            } else if (retryCount >= maxRetries) {
                console.log('PostHog feature flags not available after maximum retries');
                clearInterval(checkInterval);
            }
        }, retryInterval);
    }
}

// Start checking for PostHog readiness
waitForPostHogAndAddRoutes();

// Global error handling for NavigationDuplicated
const originalPush = router.push;
router.push = function push(location) {
    return originalPush.call(this, location)?.catch(err => {
        if (err.name !== 'NavigationDuplicated' && !err.message.includes('Navigation cancelled')) {
            throw err;
        }
    });
};

const originalReplace = router.replace;
router.replace = function replace(location) {
    return originalReplace.call(this, location)?.catch(err => {
        if (err.name !== 'NavigationDuplicated') {
            throw err;
        }
    });
};

// BeforeEach guard to check for open drawers
router.beforeEach((to, from, next) => {
    const drawers = store.state[commonModule].drawerModels;
    if (drawers.length > 0) {
        EventBus.$emit(EVENT_BUS.COMMON.WARNING_CLOSE_MODAL, to);
        return;
    }
    next();
});

export default router;